import { lookupStorageKey } from '../apollo/cache'
import { getDefaultLandingPage } from './getDefaultLandingPage'

export function redirectAfterLogin(
  user: Record<string, any>,
  existingState: Record<string, any> = {},
) {
  const nextState = {
    ...existingState,
    authenticated: true,
    user,
    timestamp: Date.now(),
  }

  window.localStorage.setItem(lookupStorageKey, JSON.stringify(nextState))
  document.documentElement.style.overflow = ''
  document.body.style.overflow = ''
  window.location.assign(getDefaultLandingPage(user))
}
